import React from 'react';
import { Navbar } from '../components/landing/Navbar';
import { HeroSection } from '../components/landing/HeroSection';
import { ValueProposition } from '../components/landing/ValueProposition';
import { HowItWorks } from '../components/landing/HowItWorks';
import { FeaturesGrid } from '../components/landing/FeaturesGrid';
import { UseCases } from '../components/landing/UseCases';
import { Comparison } from '../components/landing/Comparison';
import { Pricing } from '../components/landing/Pricing';
import { Footer } from '../components/landing/Footer';
import { useLandingVariant } from '../contexts/LandingVariantContext';
import {
  HeroSectionV2,
  ProblemGap,
  FeatureTiers,
  Differentiation,
  PrivacyArchitecture,
  UseCasesV2,
  Ecosystem
} from '../components/landing/v2';

function LandingPageOriginal() {
  return (
    <>
      <HeroSection />
      <ValueProposition />
      <HowItWorks />
      <section id="features">
        <FeaturesGrid />
      </section>
      <section id="use-cases">
        <UseCases />
      </section>
      <Comparison />
      <section id="pricing">
        <Pricing />
      </section>
    </>
  );
}

function LandingPageV2Content() {
  return (
    <>
      <HeroSectionV2 />
      <ProblemGap />
      <section id="features">
        <FeatureTiers />
      </section>
      <PrivacyArchitecture />
      <Differentiation />
      <section id="use-cases">
        <UseCasesV2 />
      </section>
      <Ecosystem />
      <section id="pricing">
        <Pricing />
      </section>
    </>
  );
}

export function LandingPage() {
  const { isV2 } = useLandingVariant();

  return (
    <div className="min-h-screen bg-surface-900 overflow-x-hidden">
      <Navbar />
      <main className="overflow-visible">
        {isV2 ? <LandingPageV2Content /> : <LandingPageOriginal />}
      </main>
      <Footer />
    </div>
  );
}